import { useEffect, useRef } from "react";
import { useRecordEvent } from "@Libs/Events/hooks/useRecordEvent";

const OFFCANVAS_ID_PREFIX = "offcanvas-profil-sp-";

export const useTrackSpProfileOpened = () => {
  const { recordEvent } = useRecordEvent(
    { key: "service_request.sp_profile_opened" },
    { triggerOnMount: false }
  );

  // recordEvent is a fresh callback each render; a ref keeps the listener attached once
  const record = useRef(recordEvent);
  useEffect(() => {
    record.current = recordEvent;
  });

  useEffect(() => {
    const handleShow = (event: Event) => {
      const offcanvas = event.target as HTMLElement;
      if (!offcanvas?.id?.startsWith(OFFCANVAS_ID_PREFIX)) return;

      const trigger = (event as Event & { relatedTarget?: HTMLElement })
        .relatedTarget;
      const { serviceRequestId, serviceProviderId, contractId } =
        offcanvas.dataset;

      record.current({
        data: {
          serviceRequestId: Number(serviceRequestId),
          serviceProviderId: Number(serviceProviderId),
          contractId: contractId ? Number(contractId) : undefined,
          fromWhere: trigger?.dataset.trackingSource ?? "unknown",
        },
      });
    };

    document.addEventListener("show.bs.offcanvas", handleShow);
    return () => document.removeEventListener("show.bs.offcanvas", handleShow);
  }, []);
};
